import { render, staticRenderFns } from "./RefundOrEmdTemplateMobileView.vue?vue&type=template&id=135ca391&scoped=true&"
import script from "./RefundOrEmdTemplateMobileView.vue?vue&type=script&lang=js&"
export * from "./RefundOrEmdTemplateMobileView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135ca391",
  null
  
)

export default component.exports